import React,{useState, useEffect}  from "react";
import { getRegistroRecepciones } from "../../services/RegistroRecepciones";

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import HeaderStatsDrop from "../../components/Headers/HeaderStatsDrop.js";
import { fetchUser } from '../../utils/fetchUser';

const DashboardNDropoff = () =>{
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('InicioAnno')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial

  const [implementaP, setImplementaP] = useState(0); // Total Equipos Implementados Pendientes
  const userInfo = fetchUser();

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayYear = new Date(today.getFullYear(), 0, 1);
    if(Como === 'InicioAnno') return firstDayYear;
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

    useEffect(()=>{
      const fetchData = async () => {

          const dataRD = await getRegistroRecepciones(selectedDate.toISOString(),selectedDateEnd.toISOString(),userInfo.usuario);
          if (dataRD){
            const sumaRetiros = dataRD.reduce((accumulator, { cantidad }) => {
              return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
            }, 0);
            setImplementaP(sumaRetiros);
          }

      
      };
      fetchData();
    },[selectedDate,selectedDateEnd]); 


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  return (
    <>

    <div className="bg-white dark:bg-secondary-dark-bg p-4 max-w-4xl mx-auto rounded-2xl shadow-md mt-6">
      <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                  />
                </div>
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDateEnd}
                    handleDateChange={handleDateChangeEnd}
                  />
                </div>
                
            </div>

      <HeaderStatsDrop 
        entregasT={implementaP}
        selectedDate={selectedDate.toISOString()}
        selectedDateEnd={selectedDateEnd.toISOString()}
      />

      </div>
    </>
  );
}

export default DashboardNDropoff;